




































































































// TODO: 考虑将type抽出来，进一步封装，自由度更高
import { VNodeData } from 'vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { uploadImage, uploadSecureImage } from '@api/controll';

export enum ViewType {
    input = 'input',
    image = 'image',
    radio = 'radio',
}

export interface SelectItem {
    value: boolean;
    text: string;
    selected: boolean;
    id: string;
}

export enum UploadImageStatus {
    success,
    pending,
    fail,
}

export const Entry = Vue.extend({
    props: {
        name: {
            type: String,
            default: '默认',
        },
        required: {
            type: Boolean,
            default: false,
        },
        maxLen: {
            type: Number,
            default: 524288,
        },
        // input的值
        value: {
            type: [String, Boolean, Number],
            default: '',
        },
        // 图片列表
        imageList: {
            type: Array,
            default: function () {
                return [];
            },
        },
        // 单选框、多选框选项
        selectList: {
            type: Array,
            default: function () {
                return [];
            },
        },
        inputHeight: {
            type: Number,
            default: 38,
        },
        type: {
            type: String,
            default: 'input', // 目前支持input image
        },
        mt: {
            type: [String, Number],
            default: 0,
        },
        mb: {
            type: [String, Number],
            default: 0,
        },
        mutli: {
            type: Boolean,
            default: true,
        },
        imglimitSize: {
            type: Number,
            default: NaN,
        },
        sizeLimit: {
            type: [Array, Boolean],
            default: false,
        },
        secure: {
            type: Boolean,
            default: false,
        },
        accept: {
            type: String,
            default: '.png, .jpeg, .jpg',
        },
        isFile: {
            type: Boolean,
            default: false,
        },
        isShowTextNum: {
            type: Boolean,
            default: false,
        },
        formType: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
});

@Component({
    name: 'entry',
})
export default class extends Entry {
    innerSelectedValue: any = this.value;

    @Watch('value')
    menuIdChange(val: number) {
        this.innerSelectedValue = val;
    }

    get selectedValue() {
        const defaultSelected = (this.selectList as SelectItem[]).find(
            (item) => item.selected,
        );
        if (defaultSelected) {
            return defaultSelected.value;
        }
        return '';
    }

    set selectedValue(val) {
        this.innerSelectedValue = val;
        this.$emit('update:value', val);
    }

    viewType: any = ViewType;

    // 使用的时候过滤出成功的
    get uploadImageList() {
        return this.imageList || [];
    }

    get uniqueRadioName() {
        return '_' + Math.random().toString(36).substr(2, 9);
    }

    preventEnter(e: KeyboardEvent) {
        if (e.keyCode === 13) {
            e.preventDefault();
        }
    }

    convertStatus(status: UploadImageStatus): string {
        switch (status) {
            case UploadImageStatus.pending:
                return '上传中';
            case UploadImageStatus.success:
                return '上传成功';
            case UploadImageStatus.fail:
                return '上传失败';
            default:
                return '';
        }
    }

    get paddingB() {
        let padding = 0;
        const directives = (this.$vnode.data as VNodeData).directives;
        if (directives && directives.length) {
            padding = 8;
        }
        if (this.$slots.tips) {
            padding = 8;
        }
        return padding;
    }

    get inputVal() {
        return this.value;
    }

    set inputVal(newVal) {
        this.$emit('update:value', newVal);
    }

    deleteCurImage(index: number) {
        this.uploadImageList.splice(index, 1);
        this.$emit('update:imageList', this.uploadImageList);
    }

    get notZero() {
        return this.imageList.filter(
            (img: any) => img.status === UploadImageStatus.success,
        ).length;
    }

    isValidSize(file: any) {
        return new Promise((resolve) => {
            if (!this.sizeLimit) {
                resolve(true);
                return;
            }
            let tempImg: any = new Image();
            let blobUrl: any = URL.createObjectURL(file);

            tempImg.onload = () => {
                URL.revokeObjectURL(blobUrl);
                if (
                    // @ts-ignore
                    tempImg.width <= this.sizeLimit[0] &&
                    // @ts-ignore
                    tempImg.height <= this.sizeLimit[1]
                ) {
                    resolve(true);
                } else {
                    resolve(false);
                }

                tempImg = blobUrl = null;
            };
            tempImg.onerror = () => {
                resolve(false);
                tempImg = blobUrl = null;
            };
            (tempImg as any).src = blobUrl;
        });
    }

    async uploadImageAction(event: Event) {
        const files = (event.target as HTMLInputElement).files;
        let index: number;
        const uploadFn = this.secure ? uploadSecureImage : uploadImage;

        if (files !== null && files[0]) {
            const name = files[0].name;
            if (!(await this.isValidSize(files[0]))) {
                this.$message.error('图片尺寸过大');
                (event.target as HTMLInputElement).value = '';
                return;
            }

            if (
                !isNaN(this.imglimitSize) &&
                files[0].size > this.imglimitSize
            ) {
                this.$message.error('文件过大');
                (event.target as HTMLInputElement).value = '';
                return;
            }
            try {
                this.uploadImageList.push({
                    url: '',
                    name,
                    status: UploadImageStatus.pending,
                });

                index = this.uploadImageList.length - 1;
                const res = await uploadFn(files[0], {
                    type: this.formType,
                });
                if (res.data.result === 1) {
                    (this.uploadImageList[index] as any).url = this.secure
                        ? (res.data as any).path
                        : (res.data as any).uri;
                    (this.uploadImageList[index] as any).status =
                        UploadImageStatus.success;
                } else {
                    (this.uploadImageList[index] as any).status =
                        UploadImageStatus.fail;
                    this.$message.error(
                        res.data.error_msg || '上传失败，请重试',
                    );
                }
                this.$emit('update:imageList', this.uploadImageList);
            } catch (e) {
                this.$message.error('服务器错误');
            } finally {
                (event.target as HTMLInputElement).value = '';
            }
        }
    }
}
